<template>
  <section class="mt-5 flex flex-col gap-5">
    <p class="text-left text-body-color">
      Review your Cargo Insurance policy already on file.
    </p>
    <div
      class="group w-full rounded-md border border-transparent hover:border-yellow-500"
    >
      <a
        :href="cargoPolicy?.attachment_url"
        target="_blank"
        class="flex items-center justify-between gap-2 rounded-md border border-light-gray px-6 py-4 text-dark-gray group-hover:border-yellow-500 group-hover:bg-yellow-10 group-hover:text-yellow-500"
      >
        <div class="flex gap-2 text-dark-gray">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="h-8 w-8"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
            />
          </svg>
          <div class="flex flex-col items-start justify-center gap-0">
            <span class="leading-tight text-dark-gray">
              Cargo Insurance Policy
            </span>
            <span
              class="hidden text-left text-xxs text-gray-over-dark sm:inline"
            >
              {{ cargoPolicy?.attachment_filename || '' }}
            </span>
          </div>
        </div>
        <div
          class="flex items-center gap-2 text-gray-over-dark group-hover:text-yellow-500"
        >
          <p class="m-0">View</p>
          <svg
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 5L0.749999 0.669874L0.749999 9.33013L6 5Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </a>
    </div>
  </section>
</template>
<script setup>
import { defineProps } from 'vue';

defineProps({
  cargoPolicy: {
    type: Object,
    required: true,
  },
});
</script>
